<template>
  <div class="outline">
    <Banner></Banner>
  </div>
</template>

<script>
import {getLinkList} from "@/api/common";
import Banner from "../../components/common/banner";
export default {
  name: "OutLine",
  components: { Banner },
  data() {
    return {
      classNameA: "colA",
      classNameB: "colA",
      classNameC: "colA",
      classNameD: "colA",
      wailianA:'',
      wailianB:''
    };
  },
  mounted(){
   this.getInfoFunction()
  },
  methods: {
    async getInfoFunction() {
      const { code, data } = await getLinkList();
      if (code == 200) {
        this.wailianA = data[0].url
        this.wailianB = data[1].url
      }
    }, 
    towailianA(){
      window.open(this.wailianA, '_blank')
    },
    towailianB(){
      window.open(this.wailianB, '_blank')
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ticket/index.vue